import { makeStyles } from '@material-ui/core'

const useErrorStyles = makeStyles((theme) => {
    const mobileBreakpoint = theme.breakpoints.down('sm')
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            backgroundImage: 'none !important',
            [mobileBreakpoint]: {
                backgroundImage: 'none !important'
            }
        },
        inUsaErrorWrapper: {
            minHeight: 'calc(100vh - 208px)',
            display: 'flex',
            alignItems: 'center',
            marginBottom: 0,
            maxWidth: '1441px',
            width: '100%',
            padding: '24px 88px',
            boxSizing: 'border-box',
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        trapezoidBgInUsaError: {
            position: 'relative',
            zIndex: 1,
            '&::before': {
                content: '""',
                background: 'linear-gradient(234deg, #005C82 28.58%, #0B9EDB 99.46%)',
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                clipPath: 'polygon(95% 0, 100% 0, 100% 100%, 37.5% 100%)'
            }
        },
        wrapper: {
            width: '557px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: '40px'
        },
        textGroup: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            gap: '32px'
        },
        title: {
            width: '100%',
            margin: 0,
            color: '#212121',
            fontFamily: 'Roboto',
            fontSize: '48px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '68px'
        },
        description: {
            width: '100%',
            margin: 0,
            color: '#212121',
            fontFamily: 'Roboto',
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '34px'
        },
        buttonRow: {
            display: 'flex',
            alignItems: 'flex-start',
            alignSelf: 'stretch'
        },
        backBtn: {
            width: '150px',
            height: '30px',
            padding: '4px 8px',
            border: '2px solid #007DB8',
            borderRadius: '4px',
            color: '#007DB8',
            fontFamily: 'var(--font-family-bold)',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '22px',
            textTransform: 'capitalize'
        }
    }
})

export default useErrorStyles
